<div #panelMenu [id]="id" class="ignite-panel-menu-container">
  @if (!singleItemMode) {
    <div>
      <div class="ignite-panel-menu" (click)="toggleMenu($event)">
        @for (option of menuOptions; track option) {
          <span class="ignite-panel-menu-indicator">
            @if (option.selectedIndicator && option.selected) {
              <i class="fas" [ngClass]="option.selectedIndicator"></i>
            }
            @if (option.unselectedIndicator && !option.selected) {
              <i class="fas" [ngClass]="option.unselectedIndicator"></i>
            }
          </span>
        }
        <i class="fal fa-ellipsis-v"></i>
      </div>
      <div #popup class="ignite-panel-menu-popup" [class.opened]="isOpened">
        @for (option of menuOptions; track option) {
          <div
            [id]="option.selectLabel + '-panel-item' | replace : '[ ]' : ''"
            class="ignite-panel-menu-option"
            (click)="onOptionClick($event, option)"
            >
            @if (!option.selected && option.selectIcon !== null) {
              <i class="fal" [ngClass]="option.selectIcon"></i>
            }
            @if (option.selected && option.unselectIcon !== null) {
              <i class="fal" [ngClass]="option.unselectIcon"></i>
            }
            <span [ngStyle]="{ color: option.textColor === null ? 'black' : option.textColor }">
              {{ option.selected ? option.unselectLabel : option.selectLabel }}</span
              >
            </div>
          }
        </div>
      </div>
    }
    @if (singleItemMode) {
      <div class="ignite-panel-menu-single">
        @for (option of menuOptions; track option) {
          <div
            [id]="option.selectLabel + '-panel-item' | replace : '[ ]' : ''"
            class="ignite-panel-menu-option"
            >
            @if (!option.selected && option.selectIcon !== null) {
              <i
                class="fal"
                [ngClass]="option.selectIcon"
                [ignitetooltip]="option.selectLabel"
                (click)="onOptionClick($event, option)"
              ></i>
            }
            @if (option.selected && option.unselectIcon !== null) {
              <i
                class="fal"
                [ngClass]="option.unselectIcon"
                [ignitetooltip]="option.unselectLabel"
                (click)="onOptionClick($event, option)"
              ></i>
            }
          </div>
        }
      </div>
    }
  </div>
